import { Box, Typography, Grid, Button } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";

const PageBreak = () => <div className="page-break" />;

const MultiColumns = ({
  title,
  data,
  columns,
  questionary,
  url,
  isEditing,
}) => {
  let gridSize = { xs: 12 };
  const navigate = useNavigate();

  if (columns === 2) {
    gridSize = { xs: 12, md: 6 };
  } else if (columns === 3) {
    gridSize = { xs: 12, sm: 6, md: 4 };
  } else if (columns === 4) {
    gridSize = { xs: 12, sm: 6, md: 3 };
  } else if (columns === 5) {
    gridSize = { xs: 12, sm: 6, md: 2.4 };
  }

  const getValueByPath = (obj, path) => {
    return path?.split(".").reduce((acc, part) => acc?.[part], obj);
  };

  console.log("first12", data);

  return (
    <Box
      sx={{
        backgroundColor: "#F9F9F9",
        padding: "24px",
        mt: "1rem",
        borderRadius: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          borderBottom: "1px solid #BBBBBB",
          paddingBottom: "10px",
          mb: "1rem",
        }}
      >
        <Typography
          sx={{
            fontSize: "20px",
            lineHeight: "24px",
            fontWeight: 600,
            letterSpacing: "0.5px",
            fontStyle: "inter",
            textTransform: "uppercase",
          }}
        >
          {title}
        </Typography>
        {isEditing && (
          <Button
            className={`edit-button ${!isEditing ? "hide-in-pdf" : ""}`}
            sx={{
              fontSize: "16px",
              lineHeight: "24px",
              fontWeight: 500,
              letterSpacing: "0.5px",
              fontStyle: "inter",
              color: "#000000",
              textTransform: "none",
              //  borderBottom: "1px solid black",
              borderRadius: 0,
              paddingBottom: 0,
              mt: "-0.5rem",
              "&:hover": {
                backgroundColor: "#F9F9F9",
              },
            }}
            onClick={() => navigate(url)}
          >
            <EditIcon sx={{ marginRight: "4px", fontSize: "16px" }} /> Edit
          </Button>
        )}
      </Box>
      <Grid container spacing={3}>
        {questionary?.map((el, index) => {
          return (
            <Grid
              item
              {...(el?.gridSize ? el?.gridSize : gridSize)}
              key={index}
            >
              <Box
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                {el?.mainheading && (
                  <Typography
                    sx={{
                      fontSize: "16px",
                      lineHeight: "24px",
                      fontWeight: 600,
                      // letterSpacing: "0.5px",
                      fontStyle: "inter",
                      color: "#262626",
                      opacity: 0.8,
                      mb: "0.5rem",
                    }}
                  >
                    {el?.mainheading}
                  </Typography>
                )}
                {/* {title === "Sustainability" && index === 5 && <PageBreak />} */}
                {el?.question && (
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        lineHeight: "24px",
                        fontWeight: 600,
                        // letterSpacing: "0.5px",
                        fontStyle: "inter",
                        color: "#262626",
                      }}
                    >
                      {el?.question}
                    </Typography>
                  </Box>
                )}
                {el?.key && Array.isArray(getValueByPath(data, el?.key)) ? (
                  <ul
                    style={{
                      paddingLeft: "16px",
                      margin: 0,
                      marginTop: "4px",
                      marginBottom: "0px",
                    }}
                  >
                    {getValueByPath(data, el?.key)?.map((item, idx) => (
                      <li
                        key={idx}
                        style={{
                          fontSize: "14px",
                          lineHeight: "24px",
                          fontWeight: 500,
                          fontStyle: "inter",
                          color: "#000000",
                          wordBreak: "break-word",
                          marginBottom: "2px",
                        }}
                      >
                        {el?.subkey ? item?.[el.subkey] : item || "-"}{" "}
                        {el?.subkey2 ? item?.[el.subkey2] : ""}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <Typography
                    sx={{
                      fontSize: "14px",
                      lineHeight: "24px",
                      fontWeight: 500,
                      fontStyle: "inter",
                      color: "#000000",
                      opacity: 0.7,
                      wordBreak: "break-word",
                      mt: !el?.key && "-1.5rem",
                    }}
                  >
                    {(() => {
                      const value = getValueByPath(data, el?.key);
                      const unit = el?.key2
                        ? getValueByPath(data, el?.key2)
                        : "";
                      if (value === true) return "Yes";
                      if (value === false) return "No";
                      return el?.key ? (value ? value + " " + unit : "-") : "";
                    })()}
                  </Typography>
                )}
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default MultiColumns;
